// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__ZkGHu","info":"PatientInfo_info__2KtLt"};